import "core-js/modules/es.array.splice";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SvcBalanceRangeComponent',
  filters: {},
  data: function data() {
    return {
      formData: {
        priceArr: [{
          'balanceMin': 0,
          'balanceMax': 0,
          'discount': 0
        }]
      }
    };
  },
  computed: {},
  beforeCreate: function beforeCreate() {},
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      this.formData.priceArr = [{
        'balanceMin': 0,
        'balanceMax': 0,
        'discount': 0
      }];
    },
    onAddRule: function onAddRule(index) {
      var that = this;
      var nextBalanceMin = that.formData.priceArr[index].balanceMax + 1;
      that.formData.priceArr.splice(index + 1, 0, {
        'balanceMin': nextBalanceMin,
        'balanceMax': 0,
        'discount': 0
      });
    },
    onDeleteRule: function onDeleteRule(index) {
      var that = this;

      if (that.formData.priceArr.length === 1) {
        return;
      }

      that.formData.priceArr.splice(index, 1);
    },
    validateForm: function validateForm() {
      var flag = null;
      this.$refs['formData'].validate(function (valid) {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    }
  }
};